import React from 'react';
import PropTypes from 'prop-types';

import DisplayRichContent from '../../../global/components/forms/DisplayRichContent';
import BrukinsaModuleCard2 from '../../contentModule/components/BrukinsaModuleCard2';

import { checkIfRichText } from '../../../global/utils/richContentUtils';
import LandingTemplateFooter from './LandingTemplateFooter';

// proof of concept for a public landing page template
const BrukinsaTemplate = ({ templateConfig, contentModules = [], handleOpenModule, handleLoginClick, isLoggedIn }) => {
  const {
    logoUrl1
    , heroUrl1
    , header1
    , subHeader1
    , body1
    , body2
    , embedContent
    , footer
    , footerLogoUrl
    , footerCaption
    , persistentFooter
    , persistentFooterLogoUrl
    // , displayModuleDescriptions // false always because this is handled by the template itself for Brukinsa
    , showPfLogo
    , allowLogin
  } = templateConfig || {};
  const defaultTextClass = '!text-pf-black-800'

  const customFontMap = {
    h1: 'font-[teko] text-[#00205B] text-4xl'
    , h2: 'font-[teko] text-light text-[#00205B] text-3xl'
    , h3: 'font-[montserrat] font-bold text-[#0092c8] text-2xl'
    , p: `font-[montserrat] ${defaultTextClass}`
    , ol: `font-[montserrat] ${defaultTextClass}`
    , ul: `font-[montserrat] ${defaultTextClass}`
    , a: `font-[montserrat] ${defaultTextClass} underline`
  }


  return (
    <div className={`h-full min-h-fit mx-auto bg-pf-white rounded-sm ${defaultTextClass}`}>
      {/* Header Section */}
      <header className="flex flex-col py-4 gap-2" id='header-top'>
        {logoUrl1 ?
          <div className="">
            <img src={logoUrl1} alt="Client Logo" className="h-20 w-auto" />
          </div>
          :
          <div className="">
            <img src={"https://pro-ficiency-static.s3.us-east-2.amazonaws.com/atlas/slp_full_blue.png"} alt="Client Logo" className="h-12 w-auto" />
          </div>
        }
        {allowLogin && (
          <button className="btn ml-auto" onClick={handleLoginClick}>
            {isLoggedIn ? 'View Dashboard' : 'Login'}
          </button>
        )}
        <div className="w-full h-4 rounded-sm bg-gradient-to-r from-[#00205B] via-[#0092c8] to-[#0092c8]" />
      </header>
      {/* Main Content */}
      <div className="text-inherit flex flex-col min-h-screen gap-8 py-8" id="main-content">
        {/* Hero Section */}
        {(heroUrl1 || header1 || body1 || subHeader1) && (
          <section className="text-inherit flex flex-col md:flex-row md:justify-around md:gap-10">
            {(header1 || subHeader1) && (
              <div className={`flex flex-col justify-center h-full w-full md:w-1/4 my-auto`}> {/* padding & margin on text to line up with rest of the page */}
                {header1 && <h2 className="md:text-4xl font-[teko] text-[#00205B] text-center md:text-left">{header1}</h2>}
                {subHeader1 && <p className="font-[teko] text-light text-[#0092c8] text-xl text-center md:text-left">{subHeader1}</p>}
              </div>
            )}
            {embedContent && contentModules?.length > 0 && (
              <div className='w-full md:w-1/2'>
              <BrukinsaModuleCard2
                key={contentModules[0]?._id}
                contentModule={contentModules[0]}
                handleOpenModule={() => { handleOpenModule(contentModules[0]._id) }}
                displayModuleDescriptions={false} // this is handled by the template itself for Brukinsa
              />
             </div>
            )}
            <div className={`text-inherit flex flex-col justify-center text-center md:text-left h-full w-full md:w-1/4 my-auto`}> {/* padding & margin on text to line up with rest of the page */}
              {contentModules[0]?.summary && <h2 className=" whitespace-pre-line">{contentModules[0]?.summary}</h2>}
            </div>
          </section>
        )}

        {/* Body1 Section */}
        <div className='text-inherit px-10 lg:px-40'>
        {checkIfRichText(body1) &&
          <DisplayRichContent className="text-inherit border-none" content={body1} customFontMap={customFontMap} />
        }
        </div>
        {/* Body2 Section */}
        {checkIfRichText(body2) &&
          <div className="px-4 md:px-20 py-6 bg-gray-100 -mx-4 sm:-mx-20">
            <DisplayRichContent className="text-inherit border-none" content={body2} customFontMap={customFontMap} />
          </div>
        }
      </div>

      {/* Footer Section */}
      <LandingTemplateFooter
        footer={footer}
        footerLogoUrl={footerLogoUrl}
        footerCaption={footerCaption}
        expandedFooterClass='text-inherit bg-gradient-to-b from-[#fff] to-[#c6d4e1]' // took this from the brukinsa site
        persistentFooter={persistentFooter}
        persistentFooterLogoUrl={persistentFooterLogoUrl}
        showPfLogo={showPfLogo}
        customFontMap={customFontMap}
      />
    </div>
  );
};

BrukinsaTemplate.propTypes = {
  templateConfig: PropTypes.shape({
    logoUrl1: PropTypes.string
    , heroUrl1: PropTypes.string
    , header1: PropTypes.string
    , subHeader1: PropTypes.string
    , body1: PropTypes.object
    , embedContent: PropTypes.bool
    , footer1: PropTypes.object
    , allowLogin: PropTypes.bool
  })
  , searchParams: PropTypes.object
  , moduleLinks: PropTypes.array
  , contentModules: PropTypes.array
  , handleOpenModule: PropTypes.func
};



export default BrukinsaTemplate;